var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgWallet = function SvgWallet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.464 15.8451V12.4601C25.464 12.0112 25.2857 11.5807 24.9683 11.2633C24.6509 10.9459 24.2204 10.7676 23.7715 10.7676H7.69252C7.24364 10.7676 6.81314 10.9459 6.49573 11.2633C6.17832 11.5807 6 12.0112 6 12.4601V24.3077C6 24.7566 6.17832 25.1871 6.49573 25.5045C6.81314 25.8219 7.24364 26.0003 7.69252 26.0003H23.7715C24.2204 26.0003 24.6509 25.8219 24.9683 25.5045C25.2857 25.1871 25.464 24.7566 25.464 24.3077V20.0764",
    stroke: "currentColor",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6531 6.53601L21.2497 4.03108C21.3575 4.0007 21.4704 3.99248 21.5815 4.00692C21.6926 4.02136 21.7996 4.05816 21.8961 4.11511C21.9926 4.17205 22.0765 4.24795 22.1429 4.33823C22.2092 4.42851 22.2566 4.5313 22.2821 4.64039L22.756 6.53601",
    stroke: "currentColor",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1564 15.8447H22.9251C22.4577 15.8447 22.0789 16.2236 22.0789 16.691V19.2298C22.0789 19.6971 22.4577 20.076 22.9251 20.076H27.1564C27.6238 20.076 28.0027 19.6971 28.0027 19.2298V16.691C28.0027 16.2236 27.6238 15.8447 27.1564 15.8447Z",
    stroke: "currentColor",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.dd1ad303b49065345d8b40cfc0f168c8.svg";